'use strict';
Object.defineProperty(exports, "__esModule", { value: true });
function boxSizing(value) {
    return ({
        boxSizing: value,
        WebkitBoxSizing: value,
        MozBoxSizing: value,
    });
}
exports.boxSizing = boxSizing;
function userSelect(value) {
    return ({
        userSelect: value,
        WebkitUserSelect: value,
        MozUserSelect: value,
        MSUserSelect: value,
    });
}
exports.userSelect = userSelect;
function scale() {
    var values = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        values[_i] = arguments[_i];
    }
    return ({
        transform: "scale(" + values.join(',') + ")",
        WebkitTransform: "scale(" + values.join(',') + ")",
        MSTransform: "scale(" + values.join(',') + ")",
        OTransform: "scale(" + values.join(',') + ")",
    });
}
exports.scale = scale;
//# sourceMappingURL=Mixins.js.map


//////////////////
// WEBPACK FOOTER
// ./src/js/styles/Mixins.js
// module id = 12
// module chunks = 0